"use client";

import { FC } from "react";
import Link from "next/link";

import { useStyles } from "./styles";

interface ShortcutProps {
  url: string;
  icon: JSX.Element;
  label: string;
  onClick: () => void;
  activeIcon?: JSX.Element;
  isExternal?: boolean;
  className?: string;
  isActive?: boolean;
}

const Shortcut: FC<ShortcutProps> = ({
  url,
  icon,
  activeIcon = icon,
  label,
  onClick,
  isExternal = false,
  className,
  isActive = false,
}) => {
  const { classes, cx } = useStyles({ isActive });

  return (
    <Link
      href={url}
      className={classes.link}
      target={isExternal ? "_blank" : undefined}
    >
      <div
        className={cx(
          classes.container,
          isActive && classes.activeLink,
          className
        )}
        onClick={onClick}
      >
        <div className={classes.icon}>{icon}</div>
        <div className={classes.activeIcon}>{activeIcon}</div>
        <p className={classes.label}>{label}</p>
      </div>
    </Link>
  );
};

export default Shortcut;
